import React from "react";
import { Typography } from "@material-ui/core";
import Utils from "~/helpers/Utils";
import { useTranslation } from "react-i18next";

export default function VendorCheckoutPackage({ selectedPackage, business }) {
	const { t } = useTranslation();
	const {serviceName, quantity, packagePrice, duration, validity} = selectedPackage?.info;

	const data = {
		serviceDetails: t("serviceDetails", {
			serviceName: serviceName,
			quantity: quantity,
			session: quantity > 4 ? t("sessions") : t("session"),
			duration: duration
		}),
		price: Utils.getPostPrice(packagePrice, business?.currency),
		validity: validity
	};
	
	return (
		<>
			<div>
				<Typography noTranslate>{t("You are purchasing")}</Typography>
				<div>
					<Typography style={{ fontSize: 16, fontWeight: 600 }} noTranslate>{data?.serviceDetails}</Typography>
					<Typography style={{ fontSize: 16, fontWeight: 600 }} noTranslate>{t("Value")} {data?.price}</Typography>
				</div>
				<div style={{ marginTop: 10 }}>
					<Typography noTranslate>
						{t("Package validity until {{validity}} days after purchase", {
							validity: data?.validity
						})}
					</Typography>
				</div>
			</div>
		</>
	);
}
